import { useCallback, useEffect, useState } from "react"
import { lumi } from "@/lib/lumi"
import type { Article } from "@/types/content"

interface UseArticlesOptions {
  publishedOnly?: boolean
  limit?: number
}

export function useArticles(options: UseArticlesOptions = {}) {
  const publishedOnly = options.publishedOnly === true
  const limit = options.limit
  const [articles, setArticles] = useState<Article[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  const fetchArticles = useCallback(async () => {
    setLoading(true)
    setError("")
    try {
      const result = await lumi.entities.articles.list({
        filter: publishedOnly ? { published: true } : {},
        sort: { createdAt: -1 },
        limit: limit || 100,
      })
      setArticles((result?.list || []) as Article[])
    } catch (err) {
      console.error("Failed to load articles:", err)
      setError("Unable to load articles right now.")
      setArticles([])
    } finally {
      setLoading(false)
    }
  }, [publishedOnly, limit])

  useEffect(() => {
    void fetchArticles()
  }, [fetchArticles])

  return { articles, loading, error, fetchArticles }
}
